import React from 'react';
import Svg from 'svg-inline-react';
import { Container } from '@src/components/Container';
import FrInfoSmallSvg from '@src/svgs/fr-info-small.svg';
import { ContainerType } from '@src/components/Container/enums/containerType.enum';
import './styles.scss';

export const GrossSalaryNotice = () => (
  <Container className="gross-salary-notice" type={ContainerType.INFO_SECONDARY}>
    <Svg src={FrInfoSmallSvg} />
    <div className="gross-salary-notice__message">
      Please enter <span>gross salary</span>. Incorrect <br /> salary could lead to poor results.
    </div>
  </Container>
);
